import { CLARAVINE_TEXT } from './config'
import { NestedPaths } from './types'

export function getNestedTitleFromPath({
  keys,
  nestedPaths,
  prefix,
}: {
  keys: string[]
  nestedPaths: NestedPaths
  prefix: string | null
}): string {
  if (keys.length === 0) return `Home - ${CLARAVINE_TEXT}`

  for (const key of keys) {
    const nestedPath = nestedPaths?.[key]

    if (nestedPath === undefined) continue

    const isRootPath = keys.length === 1 && Boolean(nestedPath?.root)

    if (isRootPath) return generateTitle(nestedPath.root, prefix)

    if (typeof nestedPath === 'string') return generateTitle(nestedPath, prefix)

    keys.shift()

    return getNestedTitleFromPath({ keys, nestedPaths: nestedPath, prefix })
  }

  return CLARAVINE_TEXT
}

function generateTitle(path: string, prefix: string | null): string {
  let base = `${path} - ${CLARAVINE_TEXT}`

  if (prefix) {
    base = `${prefix} - ${base}`
  }

  return base
}
